var map = {
	"./en_US1.png": "qN+W",
	"./zh_CN1.png": "zeCk",
	"./zh_HANT1.png": "O7aO"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UrL7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile ^\.\/.*1\.png$
// module id = UrL7
// module chunks = 1